import { ApiKeys } from '@app/constants/api-keys'
import { IDistrict } from '@app/interfaces/organization/districts'
import { resolveTParams } from '@app/utils/resolve-params/resolve-params'
import localForage from 'localforage'
import { emptyOrganizationApi } from '.'
import { IRtkResponse } from './../../types'

export const districtApi = emptyOrganizationApi.injectEndpoints({
  overrideExisting: false,
  endpoints: (build) => ({
    getDistricts: build.query<
      IRtkResponse<IDistrict[]>,
      URLSearchParams | string
    >({
      query: (args = '') => ({
        url: 'dictionary/api/v1/districts',
        method: 'get',
        params: {
          ...resolveTParams(args),
        },
      }),
      transformResponse: (response: IDistrict[], meta) => {
        return { response, meta }
      },
      providesTags: (data) =>
        data
          ? [
              ...data.response.map(({ id }) => ({
                type: ApiKeys.district,
                id,
              })),
              { type: ApiKeys.district, id: 'LIST' },
            ]
          : [{ type: ApiKeys.district, id: 'LIST' }],
      async onQueryStarted(args, { queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          localForage.setItem(ApiKeys.district, data?.response)
        } catch (e) {
          console.error(e)
        }
      },
    }),
    getDistrict: build.query<IDistrict, number>({
      query: (id) => ({
        url: `dictionary/api/v1/districts/${id}`,
        method: 'get',
      }),
      providesTags: (result, error, id) => [{ type: ApiKeys.district, id }],
    }),
  }),
})

export const { useGetDistrictsQuery, useGetDistrictQuery } = districtApi
